import React from 'react'
import { NavLink } from 'react-router-dom';
import classes from './NavigationItems.module.scss'

const NavigationItems = (props) => {
    let linksContent = [
        {
            title: 'Burger Builder',
            link: '/'
        },
        {
            title: 'Authenticate',
            link: '/auth'

        }
    ]

    if (props.isAuth) {
        linksContent = [
          {
            title: "Burger Builder",
            link: "/",
          },
          {
            title: "My Orders",
            link: "/orders",
          },
          {
            title: "Logout",
            link: "/logout",
          },
        ];
    }

    
    const links = [];

    linksContent.forEach(item => {
        links.push(
            <li key={item.title} className={classes.NavigationItem}>
                <NavLink activeClassName={classes.active} exact to={item.link} onClick={props.closed}>{item.title}</NavLink>
                </li>
        )
    })

    return (
      <ul key="navLinks" className={classes.NavigationItems}>
        {links}
      </ul>
    );
}

export default NavigationItems
